import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "login_index",
    meta: { title: "登录" },
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登录" },
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/register",
    name: "register",
    meta: { title: "注册" },
    component: () => import("../views/login/register.vue"),
  },
  {
    path: "/home",
    name: "home",
    meta: { title: "企安检" },
    component: () => import("../views/home/index.vue"),
  },
  {
    path: "/my",
    name: "my",
    meta: { title: "个人中心" },
    component: () => import("../views/my/index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    meta: { title: "修改密码" },
    component: () => import("../views/my/updatePassword.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/team-invitate",
    name: "teamInvitate",
    meta: { title: "团队邀请确认" },
    component: () => import("../views/team/team-invitate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/share-invitate",
    name: "shareInvitate",
    meta: { title: "报告分享邀请确认" },
    component: () => import("../views/share/share-invitate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/report-file",
    name: "reportFile",
    meta: { title: "检查报告" },
    component: () => import("../views/report/index.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/app-download",
    name: "appDownload",
    meta: { title: "app下载" },
    component: () => import("../views/app-download/index.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/report-preview-download",
    name: "reportDownload",
    meta: { title: "报告预览下载" },
    component: () => import("../views/report-download/index.vue"),
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  //   history: createWebHistory(process.env.BASE_URL),
  // mode: 'history',
  history: createWebHashHistory(),
  routes,
});

// 添加路由守卫
router.beforeEach((to, from, next) => {
  console.log("qqqqqqq-00000000-requset", to, from, next);
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = localStorage.getItem("token"); // 检查用户是否已登录
  // console.log("qqqqqqq-00000000-----2222222",requiresAuth,isAuthenticated)
  if (
    requiresAuth &&
    !isAuthenticated &&
    to.path != "/report-file" &&
    to.path != "/app-download" &&
    to.path != "/report-download"
  ) {
    // console.log("qqqqqqq-1111111-requset",1234)
    next(`/?redirect=${to.path}&query=${JSON.stringify(to.query)}`); // 未登录，重定向到登录页
  } else {
    // console.log("qqqqqqq-22222222-requset",1234)
    next(); // 继续访问页面
  }
});

export default router;
